import { Tag } from 'antd';

export const STATUS_META = {
  DRAFT: ['Bản nháp', 'default'],
  PUBLISHED: ['Đã đăng', 'processing'],
  BOARDING: ['Đón khách', 'warning'],
  IN_PROGRESS: ['Đang chạy', 'blue'],
  COMPLETED: ['Hoàn thành', 'success'],
  CANCELLED: ['Đã hủy', 'error'],
};

export const STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(STATUS_META).map(([value, meta]) => ({ value, label: meta[0] })),
];

// Only a trip that hasn't started yet makes sense to cancel — once boarding
// or in progress, passengers may already be on the road with the driver.
export const CANCELLABLE_STATUSES = ['DRAFT', 'PUBLISHED'];

export const formatTripDate = (value) => (value ? new Date(value).toLocaleString('vi-VN') : '—');
export const formatTripMoney = (value) => (value == null ? '—' : `${Number(value).toLocaleString('vi-VN')} ₫`);

export const getRideTripErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu chuyến đi';

export function RideTripStatusTag({ status }) {
  const [label, color] = STATUS_META[status] || [status || '—', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const BOOKING_STATUS_META = {
  PENDING_DRIVER: ['Chờ tài xế', 'processing'],
  CONFIRMED: ['Đã xác nhận', 'success'],
  REJECTED: ['Tài xế từ chối', 'error'],
  EXPIRED: ['Hết hạn giữ chỗ', 'default'],
  CANCELLED: ['Đã hủy', 'error'],
  PICKUP_FAILED: ['Đón khách thất bại', 'error'],
};

export function RideBookingStatusTag({ status }) {
  const [label, color] = BOOKING_STATUS_META[status] || [status || '—', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const PAYMENT_METHOD_LABELS = {
  WALLET: 'Ví EVG',
  CASH: 'Tiền mặt',
};
